<template lang="pug">
.precaution
  treatment-indication-dropdown(v-if="item.editable && item.productItem.medication" :item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed', $event)")
  div.clickable(v-else-if="!item.editable && item.productItem.medication && item.productItem.medication.indication")
    span.font-medium.danger500--text(v-if="item.error") {{ item.productItem.medication.indication }}
    span(v-else) {{ item.productItem.medication.indication }}
</template>

<script>
import TreatmentIndicationDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentIndicationDropdown.vue'

export default {
  components: {
    TreatmentIndicationDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>